import { styled } from "@mui/material/styles";
import { PlainButton } from "components/button/plain";
import backArrowIcon from "assets/images/icons/arrow-short.svg";

export const Component = styled(PlainButton, {
  label: "back-button",
})`
  align-items: center;
  display: flex;
  justify-content: center;
  width: ${({ theme }) => theme.spacing(2.5)};
  height: ${({ theme }) => theme.spacing(2.5)};
  border-radius: 50%;
  transition: ${({ theme }) => theme.transitions.create("background")};

  margin-right: ${({ theme }) => theme.spacing(4)};

  ${({ theme }) => theme.breakpoints.up("md")} {
    width: ${({ theme }) => theme.spacing(3)};
    height: ${({ theme }) => theme.spacing(3)};

    &:hover {
      background: ${({ theme }) => theme.palette.action.hover};
    }
  }
`;

export const ArrowIcon = styled(backArrowIcon, {
  label: "arrow-icon",
})`
  fill: currentColor;
  height: auto;
  width: ${({ theme }) => theme.spacing(4.5)};
`;
